module.exports = __webpack_public_path__ + "static/media/boy.efe01b90.svg";